import PaginationComponent from './PaginationComponent';

export default PaginationComponent;
